<script setup lang="ts">
  import { computed, onMounted } from "vue";
  import { useReviewCardOptions } from "@utils/composables/reviewCard";

  const props = withDefaults(
    defineProps<{
      options: string[];
      card: Record<string, unknown>;
      inline?: boolean;
    }>(),
    { inline: false },
  );

  const { optionsContent, determineOptionsContent } = useReviewCardOptions();

  onMounted(() => determineOptionsContent(props.card));

  const line = computed(() =>
    props.options
      .map((option) => optionsContent.value?.[option])
      .filter(Boolean)
      .join(" · "),
  );
</script>

<template>
  <span
    v-if="line && props.inline"
    class="text-xs text-muted-foreground">
    · {{ line }}
  </span>
  <p
    v-else-if="line"
    class="text-13 text-muted-foreground">
    {{ line }}
  </p>
</template>
